"use client"
import Link from 'next/link'
import React, { useState } from 'react'
import { useRouter } from 'next/navigation';
import SignUp from '@/components/signup/signUp'
import OtpVerification from '@/components/signup/otpVerification';
import { useOrgLogo } from '@/hooks/useOrgLogo';




export default function Page() {
    const router = useRouter()
    const [currentComponent, setCurrentComponent] = useState<string>('signup');
    const [verificationUserId, setVerificationUserId] = useState<number | null>(null);
    const { logo: orgLogo, isLoading: logoLoading } = useOrgLogo();    

    // const [domain, setDomain] = useState('');
    // useEffect(() => {
    //     // Get the domain name from window.location
    //     const { hostname, port } = window.location;
    //     let host = hostname + ':' + port;
    //     setDomain(host);
    //     // setDomain(window.location.hostname);
    // }, []);

    return (
        <div>
            <div className="top_bar flex gap-10 md:gap-0 items-center justify-between pr-3 md:pr-10 py-2 shadow-custom1">
                <div>
                    <Link href={"/"}>
                        {logoLoading ? (
                            <div className="md:max-w-[450px] h-12 flex items-center justify-center">
                                <svg 
                                    className="animate-spin h-8 w-8 text-gray-400" 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    fill="none" 
                                    viewBox="0 0 24 24"
                                >
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            </div>
                        ) : (
                            <img 
                                className="md:max-w-[450px]" 
                                src={orgLogo} 
                                alt="hart-college-logo"
                                onError={(e: any) => {
                                    e.target.src = "/images/hart-clg-new-logo.png";
                                }}
                            />
                        )}
                    </Link>
                </div>
                <nav className="flex md:gap-3 items-center flex-col md:flex-row">
                    <span className="underline text-xs md:text-sm text-nowrap">Already have an account?</span>
                    <Link href={"/login"} className="text-lg font-medium cursor-pointer">Login</Link>
                </nav>
            </div>

            {currentComponent == 'signup' &&
                <SignUp
                    setCurrentComponent={setCurrentComponent}
                    setVerificationUserId={setVerificationUserId}
                />
            }
            {currentComponent == 'otpverification' &&
                <OtpVerification
                    verificationUserId={verificationUserId}
                />
            }

        </div>
    )
}
